import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import {
  DISPLAY_PLACEHOLDER,
  formatDocumentRef,
  isUuidLike,
} from '@/utils/displayLabels';

export type DocumentRefLinkProps = {
  /** Route path (UUID in path is fine). */
  to?: string | null;
  /** Preferred business document number (PO-2026-0058, SAR-…, etc.). */
  number?: string | null;
  /** Optional secondary name. */
  name?: string | null;
  /** Internal id — used for navigation only; never shown unless technical. */
  id?: string | null;
  /** When true, UUID may appear as label (admin / support only). */
  technical?: boolean;
  className?: string;
  style?: CSSProperties;
};

/**
 * User-facing document reference: shows business number/name, never raw UUID.
 * Links only when a safe label exists and `to` is provided.
 */
export function DocumentRefLink({
  to,
  number,
  name,
  id,
  technical = false,
  className,
  style,
}: DocumentRefLinkProps) {
  const label = formatDocumentRef({ number, name, id }, { technical });
  const safe = label !== DISPLAY_PLACEHOLDER && (technical || !isUuidLike(label));

  if (safe && to) {
    return (
      <Link to={to} className={className} style={style}>
        {label}
      </Link>
    );
  }

  return (
    <span className={className} style={style}>
      {label}
    </span>
  );
}

export default DocumentRefLink;
